import {apiWithoutToken} from '../../systems/api';
import {API_URL} from './../../systems/globalContant';

export default {
    login: (data) => apiWithoutToken.post(API_URL.LOGIN, data),
};